<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kwbjI5/tc-custom/9780830864546.jpg?1696024360130" alt="This image is the cover for the book You Found Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You Found Me
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong> <em>Outreach</em> Magazine Resource of the Year</strong> </p> <p> <strong>Many bemoan the decline of the church.</strong> We hear a steady stream of reports about how droves of people, especially younger generations, are abandoning Christianity. But new research shows that unchurched Americans are surprisingly more receptive and open to the Christian faith than is commonly assumed.</p> <p>Researcher and practitioner Rick Richardson unveils the findings of the Billy Graham Center Institute's groundbreaking studies on the unchurched. A study of 2000 unchurched people across the country reveals that the unchurched are still remarkably open to faith conversations and the church. Even unchurched "nones" and millennials are quite receptive if they are approached in particular ways.</p> <p>In this book you will also find best practices from further research into the top ten percent of churches that most effectively reach the unchurched. People who were previously unchurched share what actually moved them to faith and Christian commitment. And the research shows that churches and organizations can be transformed to become places where conversion growth becomes the new normal.</p> <p>If people tell you "the sky is falling," don't believe them. In today's troubled world, unchurched and unbelieving people are newly receptive to hearing good news. You can lead the change that will help your church reach people—who then reach others.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rick Richardson, Ed Stetzer
      </h2>
      
      <p class="authorDescription body article"><p>Rick Richardson is director of the Billy Graham Center Institute and its Church Evangelism Initiative, and professor of evangelism and leadership at Wheaton College Graduate School. He previously served as evangelism and discipleship pastor at Church of the Resurrection in Wheaton, Illinois, and was the evangelism champion who helped launch Willow Creek Community Church's first multisite campus. His books include <em>Reimagining Evangelism</em> and <em>Evangelism Outside the Box</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73c7be45